var Contact = {};


//--------------
// Functions
//--------------

/**
 * [initMap description]
 * @return {[type]} [description]
 */
Contact.initMap = function(){
	var lng_translation = 0;

	if($(window).width() > 575) {
		lng_translation = 0.005;
	}

	// The location
	var energieBeaute = { lat: $('#contact_map').data('lat'), lng: $('#contact_map').data('lng') };
	var icon = $('#contact_map').data('icon');
	// The map
	var map = new google.maps.Map(
		document.getElementById('contact_map'), {
			center: { lat: $('#contact_map').data('lat'), lng: $('#contact_map').data('lng')- lng_translation },
			scrollwheel : false,
			zoom: 16,
			styles: [{"featureType":"all","elementType":"all","stylers":[{"hue":"#ffaa00"},{"saturation":"-33"},{"lightness":"10"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#9c5e18"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"transit.line","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"saturation":"-23"},{"gamma":"2.01"},{"color":"#f2f6f6"}]},{"featureType":"water","elementType":"geometry.stroke","stylers":[{"saturation":"-14"}]}]
		});
	// The marker
	var marker = new google.maps.Marker({
		position: energieBeaute,
		map: map,
		icon: icon,
	});
}

/**
 * [sendContactMessage description]
 * @return {[type]} [description]
 */
Contact.sendContactMessage = function(){
	var datas = {};
		datas.lastname = $('#contact_lastname').val();
		datas.firstname = $('#contact_firstname').val();
		datas.email = $('#contact_email').val();
		datas.phone = $('#contact_phone').val();
		datas.message = $('#contact_message').val();
		datas.consent = $('.js-contact-info label').text();
 
	$.post({
		url: '/api/email/send',
    type: 'POST',
    data: datas
  })
	.done(function(data) {
		$('.js-form-contact')[0].reset();
		// Todo @front : Afficher un message de succès
		App.successMessage('.js-form-contact');
  })
  .fail(function(err) {
  	console.log('-- Error', err);
		App.errorMessage('.js-form-contact');
  });
}


//--------------
// Execution
//--------------

// Send contact message
$('.js-form-contact').submit(function(){
	if(!$(this).valid())
		return false;

	var honey = $('#contact_name').val();

	if(honey){
		$('.js-form-contact')[0].reset();
	} else {
		Contact.sendContactMessage();
	}

	return false;
});

// Init Contact Map
Contact.initMap();

module.exports = Contact;